import { render, staticRenderFns } from "./VerifikasiMomen.vue?vue&type=template&id=4ccddbf0&scoped=true"
import script from "./VerifikasiMomen.vue?vue&type=script&lang=js"
export * from "./VerifikasiMomen.vue?vue&type=script&lang=js"
import style0 from "./VerifikasiMomen.vue?vue&type=style&index=0&id=4ccddbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccddbf0",
  null
  
)

export default component.exports